import { SPONSOR_CONTACT_URL } from "../config/events";
import { ACCESS_LINK_UNKNOWN_EMAIL_MESSAGE } from "../lib/accessLink";

type UnknownEmailNoticeProps = {
  compact?: boolean;
};

export const UnknownEmailNotice = ({ compact = false }: UnknownEmailNoticeProps) => {
  return (
    <p
      role="alert"
      className={`rounded-md border border-rose-500/40 bg-rose-500/10 text-rose-200 ${
        compact ? "px-2 py-1.5 text-xs" : "px-3 py-2 text-sm"
      }`}
    >
      {ACCESS_LINK_UNKNOWN_EMAIL_MESSAGE}{" "}
      {SPONSOR_CONTACT_URL ? (
        <a
          href={SPONSOR_CONTACT_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="font-medium text-rose-100 underline decoration-rose-300/60 underline-offset-2 hover:text-white"
        >
          Ping Stephan
        </a>
      ) : (
        <span className="font-medium text-rose-100">Ping Stephan</span>
      )}
      .
    </p>
  );
};
